import { PropsWithChildren, FC, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import { startSalesOrderZipDownload } from '@Orders/OrderDetailsPage/OrderDetailHeaderAndFooter/SalesOrderDownloadMessage'
import { salesOrder_salesOrder_salesOrderLines_items as SalesOrderLineItemsType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'

import Button from '~/core/Button'
import { isUnknownExtFile } from '~/lib/fileExtensions'
import DownloadWarningModal from '~/core/DownloadWarningModal'

type PropType = {
    name: string
    drawingAttachmentsCount: number
    partFilesCount: number
    placement: string
    salesOrderLineItems: SalesOrderLineItemsType[]
    orderId: string
    isCpqFlagV2Enabled: boolean
}

export const PartsAndDrawings: FC<PropsWithChildren<PropType>> = props => {
    const {
        name,
        drawingAttachmentsCount,
        partFilesCount,
        placement,
        salesOrderLineItems,
        orderId,
        isCpqFlagV2Enabled,
    } = props
    const [warningModalVisible, setWarningModalVisible] = useState(false)
    const [fileNameList, setFileNameList] = useState<string[] | null>(null)

    const onClickDownloadAllFiles = () => {
        if (!warningModalVisible) {
            const attachmentFileNameList = (salesOrderLineItems || []).map(
                item => item?.quoteModelRevisionAttachment?.fileName,
            )

            const unknownExtFileNameList = attachmentFileNameList.filter(
                fileName => Boolean(fileName && isUnknownExtFile(fileName)),
            )

            if (unknownExtFileNameList.length) {
                setWarningModalVisible(true)
                setFileNameList(unknownExtFileNameList as string[])
                return
            }
        }
        if (warningModalVisible) {
            setWarningModalVisible(false)
        }

        startSalesOrderZipDownload({
            orderName: name,
            total: (partFilesCount || 0) + (drawingAttachmentsCount || 0),
        })
    }

    return (
        <>
            {warningModalVisible && (
                <DownloadWarningModal
                    visible={warningModalVisible}
                    onClose={() => setWarningModalVisible(false)}
                    onConfirm={onClickDownloadAllFiles}
                    fileNames={fileNameList || []}
                />
            )}
            <Button
                data-test-target="download-all-files"
                name="download-all-files"
                onClick={onClickDownloadAllFiles}
                placement={placement}
                style={{ marginLeft: '8px' }}
                disabled={isCpqFlagV2Enabled && orderId.includes('platform:')}
            >
                <DownloadOutlined />
                Parts and drawings
            </Button>
        </>
    )
}
